import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseSearchingCriteria } from '@app/models/customer/company';
import { OnepageTemplate, OnePageTemplateSearchingCriteria } from '@app/models/onepage-template';
import { OnepageFieldOption } from '@app/models/onepage-template-field';
import { CommonResponse } from '@app/models/common-model';


@Injectable()
export class OnepageTemplateService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: OnePageTemplateSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<OnepageTemplate>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new OnePageTemplateSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <OnepageTemplate[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(emailTemplate: OnepageTemplate): Observable<OnepageTemplate> {

        let body = JSON.stringify(emailTemplate);

        return this.httpClient.post(`${environment.API_END_POINT}/onepageTemplate`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string, forDeploy: any='N'): Observable<OnepageTemplate> {
        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate/${id}?forDeploy=${forDeploy}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplate>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    
    getButtonFieldIdList(id: string): Observable<OnepageFieldOption[]> {
        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate/buttonFieldIdList/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageFieldOption[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(emailTemplate: OnepageTemplate): Observable<OnepageTemplate> {
      
        let body = JSON.stringify(emailTemplate);

        return this.httpClient.put(`${environment.API_END_POINT}/onepageTemplate/${emailTemplate.id}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplate>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    deploy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate/deploy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    copy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate/copy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findAll(): Observable<OnepageTemplate[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplate/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    delete(templateId: string): Observable<CommonResponse> {

        return this.httpClient.delete(`${environment.API_END_POINT}/onepageTemplate/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return response;
                }),
                catchError((error: Response | any) => {
                    return this.commonService.handleHttpError(error);
                })
            );

    }

}